export const EMPLOYERS = 'employers';
export const WORKSITES = 'worksites';
export const EMPLOYEES = 'employees';
export const EMPLOYEES_COURSES = 'employees/courses';
export const EMPLOYEES_COURSES_CERT = 'employees/courses/docs';
export const AUTHZS = 'authzs';
export const AUTHZS_ISCIR = 'authzs/iscir';
export const AUTHZS_ISCIR_IMAGE = 'authzs/iscir/images';
export const AUTHZS_INTERNAL = 'authzs/internal';
export const AUTHZS_INTERNAL_CERT = 'authzs/internal/docs';
export const REMINDERS = 'reminders';
export const TASKS = 'tasks';
export const CLIENTS = 'clients';
export const CLIENTS_SUBCON = 'clients/subcon';
export const USERS = 'users';

export const DOC_ISCIR = 'documents/iscir';
export const DOC_TESTS = 'documents/tests';
export const DOC_INTERNAL = 'documents/internal';

export const CALENDAR = 'calendar';
export const REPORT_WORKSITE_DESERVENTI = 'reports/worksites/deserventi';
export const COR_CODES = 'staticdata/corcodes';
export const QUERY = '_query'

export const EMAIL_COURSE_REGISTRATION = '/email/coursereg'
